import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import './Checkin.css'
import { Helmet } from 'react-helmet-async';
import { DateTime } from 'luxon'



// @mui
import { Container, Stack, Typography, Paper, Divider, Box, Chip, Dialog, Button } from '@mui/material';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';


import QRCode from "react-qr-code";

// components
import { useCollection, useDocument } from 'react-firebase-hooks/firestore';
import Tick from '@pqina/flip';
import md5 from 'md5';
import { useNavigate } from 'react-router-dom';
import SpotifyService from '../services/spotify.service';
import { AppContext, generateRandomString, isLocalhost } from '../App';
import CheckinsService from '../services/checkins.service';
import CapacityBar, { Coming, CheckinFromQueue, WalkedIn, NoShow } from '../layouts/checkin/capacitybar';
import OpenGymDialog from '../layouts/checkin/OpenGymDialog';

export default function Checkin() {


  const { user } = useContext(AppContext);
  const navigate = useNavigate()
  const currentDay = DateTime.local().startOf('day')
  // console.log('currentDay', currentDay);

  const encodedQR = `${DateTime.local().plus({ minute: 30}).startOf('hour').valueOf().toString()}`
  // console.log('currentDay.valueOf().toString()', currentDay.valueOf().toString());

  const [timestamp, setTimestamp] = useState(currentDay);
  // const [dayHours, loadingDayHours, errorDayHours] = useCollection(QueuesService.getAllDayQueues(timestamp));
  const [displayHours, setDisplayHours] = useState([]);
  const [offsetHour, setOffsetHour] = useState(0);
  const [currentCheckedin, setCurrentCheckedin] = useState(0);
  const [allCheckins, loadingCheckins, errorQueues] = useCollection(CheckinsService.getCountOfDay(timestamp.valueOf().toString()))
  const [messageOfTheDay, loadingMessage, errorGetMessage] = useDocument(CheckinsService.getMessageOfDay(timestamp.valueOf().toString()))
  const [spotifyToken, loadingToken, errorGetTOken] = useDocument(CheckinsService.getSpotifyAuthToken())
  const [gymOpen, loadingGymOpen, errorLoadingGymOpen] = useDocument(CheckinsService.gymOpenStatus)
  const [gymOpener, setGymOpener] = useState(user);
  const [hourQRValue, setHourQRValue] = useState(encodedQR);
  const [latestCheckins, setLatestCheckins] = useState({});
  const [currentStat, setCurrentStat] = useState({});
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState('');
  const [trackinfo, setTrackinfo] = useState(<></>);
  const [newTrackCountdown, setnewTrackCountdown] = useState(100);
  const [openGymDialog, setOpenGymDialog] = useState(false);

  const timer = useRef()
  const totalRef = useRef()
  const totalInstance = useRef()
  const newTrackTimer = useRef()


  useEffect(() => {
    // console.log('user', user);
    if (!isLocalhost && (!user || !user.role)) navigate('/login')
    if (user && user.role && !['admin', 'staff', 'superadmin'].includes(user.role)) navigate('/dashboard/userprofile/userinitiated')
  }, [navigate, user]);

  // console.log('errorDayHours', errorDayHours);

  // useEffect(() => {

  //   console.log('dayHours', JSON.stringify(dayHours));
  //   console.log('loadingDayHours', JSON.stringify(loadingDayHours));
  //   console.log('errorDayHours', JSON.stringify(errorDayHours));
  // }, [dayHours, loadingDayHours, errorDayHours]);

  const handleClose = () => {
    setOpen(false);
    if (timer.current) clearTimeout(timer.current)
  };

  useEffect(() => {
    if (loadingGymOpen || isLocalhost) return
    if (gymOpen.exists) {
      setOpenGymDialog(gymOpen.data().status !== 'open')
      if (gymOpen.data().status === 'open') {
        (async () => {
          const opener = await CheckinsService.getGymOpener()
          setGymOpener(opener)
          setOpenGymDialog(true)
          setTimeout(() => {
            setOpenGymDialog(false)
          }, 5000);
          })()
      } else {
        setGymOpener({})
      }
    } else {
      setOpenGymDialog(true)
    }
  }, [gymOpen, loadingGymOpen]);

  const totalDayCheckins = useMemo(() => {

    if (loadingCheckins) return 0
    // console.log('allCheckins', allCheckins.docs);
    return allCheckins.docs.reduce((p, h) => h.data().count + p, 0)
  }, [allCheckins, loadingCheckins])

  const info = useMemo(() => {

    if (loadingMessage) return <></>
    if (!messageOfTheDay.exists()) return <></>
    if (!messageOfTheDay.data().info) return <></>
    return <Paper sx={{ bgcolor: 'brown', p: 2, mt: 2}}>
      <Typography variant="h4" sx={{ color: 'text.primary', m: 1, width: '100%' }}>
    {`INFO: ${messageOfTheDay.data().info}`}
  </Typography>
    </Paper>

  }, [loadingMessage, messageOfTheDay])

  // const trackinfo = useMemo(() => {

  //   if (token) {
  //     console.log('token', token);
  //     const sps = new SpotifyService()
  //     return sps.getPlayingTrack(token).then(r => r)
  //   }
  //   return <Paper sx={{ bgcolor:'lightgreen', m:1, p:1}}>TRACK INFO here</Paper>
  // }, [token])

  useEffect(() => {

    if (token && newTrackCountdown >= 0) {
      // console.log('token', token);

      if (newTrackTimer.current) clearTimeout(newTrackTimer.current)

      newTrackTimer.current = setTimeout(() => {

        const sps = new SpotifyService()
        console.log('getting song info');
        sps.getPlayingTrack(token).then(song => {

          // setTrackinfo(JSON.stringify(r))
          if (song && song.item) {
            setTrackinfo(<Card sx={{ display: 'flex', maxWidth:304 }}>

          <CardContent sx={{ flex: '0 0 auto'}} >
              <Typography component="div" variant="h5">
              {song.item.name}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {song.item.artists[0].name}
              </Typography>

            </CardContent>
            {/* <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          </Box> */}
          <CardMedia
            component="img"
            sx={{ width: 151 }}
            image={song.item.album.images[0].url}
            alt={song.item.name}
          />
            </Card>)
            if (song.progress_ms && song.item.duration_ms) {
              setnewTrackCountdown(song.item.duration_ms - song.progress_ms)
            }

          // if (song.item.id) {
          //   sps.getCanvasTrack(token, song.item.id, song.item.uri)
          //   .then(r => console.log(r.text()))
          //   .catch(e => console.log(e))
          // }


          } else {
            setnewTrackCountdown(-1)
          }

        })

      }, newTrackCountdown);
    }  else {
      setTrackinfo(<Paper sx={{ bgcolor:'lightgreen', m:1, p:1}}>TRACK INFO</Paper>)
    }

  }, [token, newTrackCountdown]);

  useEffect(() => {

    // async function getToken() {
    //   const ds = new DataService()
    //   const response = await ds.spotifyToken() // fetch('/auth/token');
    //   const accessToken = await response.access_token;
    //   if (accessToken) setToken(accessToken);
    // }

    // getToken();
    if (spotifyToken && spotifyToken.exists()) {
      setToken(spotifyToken.data().token)
      setnewTrackCountdown(1000)
    };

  }, [spotifyToken]);




  useEffect(() => {
    if (!totalInstance.current) return
    totalInstance.current.value = totalDayCheckins
  }, [totalDayCheckins]);

  useEffect(() => {
    if (!totalInstance.current) {
        totalInstance.current = Tick.DOM.create(totalRef.current, {
          value: totalDayCheckins
        }
      )
    }
  }, [totalDayCheckins]);


  useEffect(() => {

    const now = DateTime.local()
    // window.alert(now.set({ second: Math.ceil(now.second / 5)* 5}).diffNow().milliseconds)
    setTimeout(() => {
        const encodedQR = `${DateTime.local().plus({ minute: 30}).startOf('hour').valueOf().toString()}`
        setHourQRValue(encodedQR)
        // window.alert('changing qr now')
      setInterval(() => {
        const encodedQR = `${DateTime.local().plus({ minute: 30}).startOf('hour').valueOf().toString()}`
        if (!currentDay.hasSame(DateTime.local(), 'day')) {
          window.location.reload()
          return
        }
        setHourQRValue(encodedQR)
        // window.alert('changing qr now')
      }, 30 * 60 *  1000);

    }, now.endOf('hour').diffNow().milliseconds); // set({ minute: Math.ceil(now.minute / 10)* 10})); // .set({ minute: Math.ceil(now.second / 5) * 5}).diffNow().milliseconds); // .endOf('hour').diffNow().milliseconds); // set({ minute: Math.ceil(now.minute / 10)* 10})); // .
    // return  timer.
  }, []);


const CHECKINQR = useMemo(() => (<Box sx={{ p:2, m:1, bgcolor: 'white'}}>
  <div style={{ height: "auto", margin: "0 auto", maxWidth: 256, width: "100%" }}>
    <QRCode
    size={256}
    // title='QR CODE CHECK-IN'
    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
    value={hourQRValue}
    viewBox={`0 0 512 512`}
    />
  </div>

</Box>), [hourQRValue])

 const CheckinDialog = useMemo(() => {


  if (!loadingCheckins)

  // console.log('typeof latestCheckins', typeof latestCheckins);
    if (typeof latestCheckins === "object" && Object.values(latestCheckins).length && offsetHour  === 0) {

      if (timer.current) clearTimeout(timer.current)

      const audio = new Audio("/audios/new-notification-on-your-device-138695.mp3")

      const start = () => {
        audio.play()
      }

      start()

      setTimeout(() => {
        setOpen(true)
      }, 500);

      timer.current = setTimeout(() => {
        setLatestCheckins(o => {})
        setOpen(false)
        audio.pause()
      }, 5000);
      return (
      <Dialog
        open={open}
        onClose={handleClose}
        >
        {Object.values(latestCheckins).map(user => {

          let fullname = user.displayName
          const { rank, name, surname, unit} = user
          const surnameAlias = surname.match(/[\u0E01-\u0E2Ea-zA-Z']/)
          if (surnameAlias && surnameAlias.length) {
            fullname = [[rank, name].join(""),`${surnameAlias[0]}.`].join(" ")
          }

          return (
            <Card key={user.displayName} sx={{ width: 345 }}>
              <CardHeader
                // avatar={
                //   <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                //     R
                //   </Avatar>
                // }
                title={fullname}
                subheader={totalDayCheckins ? `ท่านคือคนที่ ${totalDayCheckins} ของวันนี้` : '-'}
              />
              <CardMedia
                component="img"
                height="345"
                image={user.pictureUrl}
                alt={user.displayName}
              />
              <CardContent>
                <Typography variant="h3" color="text.secondary">
                  {unit ? unit.abbr : 'เช็คอินเรียบร้อย'}
                </Typography>
              </CardContent>
            </Card>
            )
        })}
      </Dialog>

    )};




         // <>{Object.values(latestCheckins).map(u => JSON.stringify(u)).join(" ::: ")}</>)


    return (<></>)

  }, [latestCheckins, loadingCheckins, offsetHour, open, totalDayCheckins])


  const SpotifyLogin = () => (<Button className="btn-spotify" onClick={async () => {

    const scope = "streaming user-read-email user-read-private user-read-playback-state"

    const state = generateRandomString(16);

    const authQueryParameters = new URLSearchParams({
      response_type: "code",
      client_id: '70d425d967b841e4947bf0da068f34d8',
      scope,
      redirect_uri: isLocalhost
      ? "https://fee5-2001-fb1-5c-3d2c-fd53-8067-22e5-40c5.ngrok-free.app/flexitarmstrong/us-central1/api/auth/callback"
      : "https://us-central1-flexitarmstrong.cloudfunctions.net/api/auth/callback",
      state
    })

    console.log(`https://accounts.spotify.com/authorize/?${authQueryParameters.toString()}`);
    window.open(`https://accounts.spotify.com/authorize/?${authQueryParameters.toString()}`);


  }}>
                Login with Spotify
  </Button>
)

// href="/auth/login"
  useEffect(() => {

    const now = DateTime.local()
    const startHour = now.plus({hour:offsetHour})
    const prev2Hours = startHour.minus({hour: 1}).startOf('hour')
    const prevHour = prev2Hours.plus({hour: 1}).startOf('hour')
    const nextHour = prev2Hours.plus({hour: 2}).startOf('hour')
    const next2Hours = prev2Hours.plus({hour: 3}).startOf('hour')
    setDisplayHours([prev2Hours, prevHour, nextHour, next2Hours])

    setTimeout(() => {
      setInterval(() => {
        const now = DateTime.local()
        if ([0, 30].includes(now.minute)) {

              // console.log('updating time');
              setOffsetHour(0)
              const prev2Hours = now.minus({hour: 1}).startOf('hour')
              const prevHour = prev2Hours.plus({hour: 1}).startOf('hour')
              const nextHour = prev2Hours.plus({hour: 2}).startOf('hour')
              const next2Hours = prev2Hours.plus({hour: 3}).startOf('hour')
              setDisplayHours([prev2Hours, prevHour, nextHour, next2Hours])
        }
        if (!now.hasSame(timestamp, 'day')) setTimestamp(now.startOf('day'))
      }, 60000);
    }, now.startOf('minute').plus({minute: 1}).valueOf() - now.valueOf() );


      // setTimeout(() => {
      //    setInterval(() => {
      //       const now = DateTime.local()
      //       const prevHour = now.minus({minute: 30}).startOf('hour')
      //       const nextHour = now.plus({ minute: 30 }).startOf('hour')
      //       setDisplayHours([prevHour, nextHour])
      //     }, 1 * 60 * 1000);
      // }, Duration.fromMillis(nextHour.valueOf() - now.valueOf()).milliseconds);

  }, [offsetHour, timestamp]) // DateTime.local().startOf('hour').valueOf().toString()

  return (
    <>
      <Helmet>
        <title> ยอดผู้ใช้ </title>
      </Helmet>

      <Container maxWidth >



        <Stack direction={{sm : 'column', md: 'row' }} spacing={1} >


          <Stack direction={'column'} flex={{ sm: 1, md: 3}} mt={{ xs: 4, sm: 4, md:6, lg:6}}  >
          {info && <>{info}<Divider dark sx={{ p:2, m:2 }} /></>}

          <Stack direction="row" alignItems="center" justifyContent="space-between" >
            <Typography variant="h4" gutterBottom>
              ยอดผู้ใช้ในรอบ
            </Typography>

            {/* <Button variant="contained" startIcon={<Iconify icon="ic:twotone-refresh" />}>
              REFRESH
            </Button> */}
          </Stack>
            <Chip label="-" variant='outlined' color="primary" sx={{ maxWidth: 36, m:1}}  onClick={() => setOffsetHour(h => h-1)} />
            {displayHours.map(hour => <CapacityBar key={hour.valueOf()} time={hour} current={DateTime.local().hasSame(hour, 'hour')} past={DateTime.local().minus({ hour: 1}) > hour} setLatestCheckins={setLatestCheckins} />)}
            <Chip label="+" variant='outlined' color="warning" sx={{ maxWidth: 36, m:1}}   onClick={() => setOffsetHour(h => h+1)} />

            <Divider dark sx={{ p:2, m:2 }} />

            <Stack mb={5} direction={{xs : 'column', sm: 'row' }} alignItems={{ sm: 'flex-start', md: "center"}} sx={{ m: 2}} >
              {/* <BlogPostsSearch posts={POSTS} />
              <BlogPostsSort options={SORT_OPTIONS} /> */}
              <Typography variant='caption' >Legends:</Typography>
              <Stack direction={'row'} spacing={1} sx={{ p: 1}}>
                <Coming><Typography variant='caption'>จองรอบ</Typography></Coming>
                </Stack>
              <Stack direction={'row'} spacing={1} sx={{ p: 1}}>
                <CheckinFromQueue><Typography variant='caption'>เช็คอินรอบจอง</Typography></CheckinFromQueue>
                </Stack>
              <Stack direction={'row'} spacing={1} sx={{ p: 1}}>
              <WalkedIn><Typography variant='caption'>Walked-in</Typography></WalkedIn>
                </Stack>
              <Stack direction={'row'} spacing={1} sx={{ p: 1}}>
              <NoShow><Typography variant='caption'>No-Show</Typography></NoShow>
                </Stack>

            </Stack>

          </Stack>


          <Paper elevation={3} sx={{ p:1, pt:4, ml:1, mr:1, bgcolor: 'white',
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"}} >
            <Box sx={{ textAlign: 'center',  color: 'black' }} >
                  <Stack direction={'column'}>

                  <Typography gutterBottom variant="h6">
                    The Runway Lab
                  </Typography>
                    <Typography variant="body2" gutterBottom>
                      ยอดรวมวันนี้
                    </Typography>
                    <div ref={totalRef} className="totalTick" id="dots-size" >
                    <div data-repeat="true" aria-hidden="true">
                      <span data-view="flip" />
                    </div>


                    </div>
                    {/* <Typography variant="h4" gutterBottom sx={{ textAlign: 'center'}}>

                    </Typography>  */}
                  </Stack>

                  <Paper sx={{ p:1, m:1, mb: 1, bgcolor: 'DodgerBlue'}} >
                    <Typography variant="body" sx={{ color: 'text.primary', m: 1 }}>
                    เช็คอินด้วย QR CODE
                  </Typography>
                  </Paper>
                {CHECKINQR}
                <Paper sx={{   m:1,  bgcolor: 'lightblue'}} >
                  <Typography variant="h6" sx={{ color: 'black', m: 1, mt:0 }}>
                    ใช้เมนูเช็คอินในไลน์
                  </Typography>

                  </Paper>



                </Box>
                {/* {`token ${JSON.stringify(token)}`} */}
                { (token && newTrackCountdown >= 0) ? trackinfo : <SpotifyLogin /> }
               {/* <Box component="img"
                      src="/assets/L_gainfriends_2dbarcodes_BW.jpg"
                      sx={{ width: {xs: '100%', sm: '50%', md: 200},
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    mb: 2}}
                  />
                   */}

          </Paper>


          {/* <Stack direction='column' flex={{ sm: 1, md: 1}} sx={{ bgcolor: '#F00'}}>
                <Box sx={{ textAlign: 'center' }}>
                <Typography gutterBottom variant="h6">
                  The Runway Lab
                </Typography>

                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Add friend : scan QR Code
                </Typography>
              </Box>
              <Box component="img"
                    src="/assets/2dbarcodes_BW/L_gainfriends_2dbarcodes_BW.png"
                    sx={{ width: 200 }}
                />
          </Stack> */}



        </Stack>



        </Container>
        <OpenGymDialog open={openGymDialog} setOpen={setOpenGymDialog} opener={gymOpener} />
        {CheckinDialog}
    </>
  );
}
